import { Route, Routes, Navigate } from "react-router-dom";
import { AdminLayout } from "../layouts/admin/AdminLayout";
import { AdminProtectedRoute } from "../components/auth/AdminProtectedRoute";
import { NotFound } from "../pages/NotFound";
import { AdminAuthProvider } from "../contexts/AdminAuthContext/provider";
import AdminLeads from "@/pages/admin/Leads";

export function SalesRoutes() {
  return (
    <AdminAuthProvider>
      <Routes>
        <Route
          element={
            <AdminProtectedRoute
              allowedRoles={["SALES"]}
              loginPath="/auth/sales/login"
            >
              <AdminLayout />
            </AdminProtectedRoute>
          }
        >
          <Route index element={<Navigate to="leads" replace />} />
          <Route path="leads" element={<AdminLeads />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </AdminAuthProvider>
  );
}
